<template>
  <SpectreText
    size="sm"
    color="secondary"
  >
    By signing into spectre.uk.com, I agree to the <SpectreTextLink
      as="a"
      href="https://spectre.uk.com/privacy"
    >
      Privacy Policy
    </SpectreTextLink> and
    <SpectreTextLink
      as="a"
      href="https://spectre.uk.com/terms"
    >
      Terms of service
    </SpectreTextLink>.
  </SpectreText>
</template>

<script setup lang="ts">
import { SpectreText, SpectreTextLink } from '@agentsoftware/spectre-ui';
</script>
